@if ((auth?.isLoading$ | async)) {
<loading-page></loading-page>
} @else { @if ((auth?.isAuthenticated$ | async)) { @if ((messageCenterStore.criticalMessages()); as criticalMessages) {
<div class="critical-msg">
    @for (critical of criticalMessages; track critical.id) {
    <ev-critical-alert>
        <span>{{ critical.published | date : "dd.MM.yy 'kl' hh:mm" }} {{ critical.text }}</span>
    </ev-critical-alert>
    }
    @if (messageCenterStore.priorityMessages().length) {
        <ev-priority-news-alert [messages]="messageCenterStore.priorityMessages()" (dismiss)="onDismissPriorityMessage($event)"></ev-priority-news-alert>
    }
</div>
}
<router-outlet></router-outlet>
} @else {
<public-router-outlet></public-router-outlet>
} }
